import { styled } from "styled-components";
import SiteLogo from "../../assets/svg/site.svg";
import WhatsappIcon from "../../assets/svg/wpp.svg";
import UploadIcon from "../../assets/svg/upload.svg";
import LinkedinLogo from "../../assets/svg/linkedin.svg"
import DownloadIcon from "../../assets/svg/download.svg";
import AsteriscoIcon from "../../assets/svg/asterisco.svg";
import InstagramLogo from "../../assets/svg/instagram.svg";
import AmigoIcon from "../../assets/svg/amigocompletelogo.svg";
import { FONTSIZE, FONTWEIGHT, FONTCOLOR, BACKGROUND} from "../../constants/theme";

export const SignStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

SignStyled.TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

SignStyled.Title = styled.p`
  margin: 0px;
  font-size: ${FONTSIZE.h1};
  font-weight: ${FONTWEIGHT.bold};
`;

SignStyled.SubTitle = styled.p`
  color: ${FONTCOLOR.kindablack};
  font-size: ${FONTSIZE.smallP};
  font-weight: ${FONTWEIGHT.normal};
  margin: 0px;
`;

SignStyled.FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  gap: 16px;
`;

SignStyled.InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

SignStyled.InputText = styled.p`
  font-size: ${FONTSIZE.smallP};
  font-weight: ${FONTWEIGHT.normal};
  margin: 0px;
`;

SignStyled.UploadInput = styled.input.attrs({
  type: "file"
})`
  display: none;
`;

SignStyled.UploadLabel = styled.label`
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 8px;
    text-align: center;
    color: ${FONTCOLOR.black};
    font-size: ${FONTSIZE.smallP};
    font-weight: ${FONTWEIGHT.normal};
    gap: 8px;
    border: 1px solid #CDDAE4;
    display: flex;
    transition: 0.5s;

    &:hover {
        background-color: #f0f0f0;
    }
`;

SignStyled.TextInput = styled.input.attrs({
  type: "text"
})`
    border-radius: 8px;
    border: 1px solid #D9E1E8;
    width: 281px;
    height: 18px;
    padding: 11px 9px;
    font-size: ${FONTSIZE.bigP};
    font-style: normal;
    font-weight: ${FONTWEIGHT.normal};

    &::placeholder {
    color: #888; /* Cor desejada para o placeholder */
    font-weight: 200;
  }
`;

SignStyled.CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

SignStyled.Checkbox = styled.input.attrs({
  type: "checkbox"
})`
  border-radius: 2px;
  width: 16px;
  height: 16px;
  border: 2px solid #E2E8F0;
`;

SignStyled.CheckBoxText = styled.p`
  color: ${FONTCOLOR.kindablack};
  font-size: ${FONTSIZE.bigP};
  font-weight: ${FONTWEIGHT.normal};
  margin: 0px;
`;

SignStyled.SignatureWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  width: 340px;
`;

SignStyled.SignatureTitle = styled.p`
  font-size: ${FONTSIZE.bigP};
  margin: 0px;
  font-weight: ${FONTWEIGHT.bold};
`;

SignStyled.SignContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

SignStyled.SignUpperPart = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

SignStyled.PhotoContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${props => (props.hasImage ? 'transparent' : '#ccc')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

SignStyled.Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

SignStyled.SignDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

SignStyled.SignDataUpperPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

SignStyled.SignName = styled.p`
  margin: 0px;
  color: ${FONTCOLOR.fadedblack};
  font-size: ${FONTSIZE.h2};
  font-weight: ${FONTWEIGHT.bold};
`;

SignStyled.SignRole = styled.p`
  color: ${FONTCOLOR.darkgray};
  font-size: ${FONTSIZE.tinyP};
  font-style: normal;
  font-weight: ${FONTWEIGHT.normal};
  margin: 0px;
`;

SignStyled.SignDataLowerPart = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

SignStyled.SignNumber = styled.p`
  color: ${FONTCOLOR.black};
  font-size: ${FONTSIZE.smallP};
  font-weight: ${FONTWEIGHT.almostbold};
  margin: 0px;
`;

SignStyled.SignWhatsappDiv = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #CDDAE4;

  a {
    display: inline-block;
  }
`;

SignStyled.SignWhatsappIcon = styled.img.attrs({
  src: WhatsappIcon
})`
    cursor: pointer;
`;

SignStyled.SignMidPart = styled.div`
  width: 340px;
  height: 1px;
  background-color: #CDDAE4;
`;

SignStyled.SignLowerPart = styled.div`
  display: flex;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

SignStyled.AmigoSvg = styled.img.attrs({
  src: AmigoIcon
})``;

SignStyled.RightWrapper = styled.div`
  display: flex;
  gap: 14px;
`;

SignStyled.SiteIcon = styled.img.attrs({
  src: SiteLogo
})`
    cursor: pointer;
`;

SignStyled.InstagramIcon = styled.img.attrs({
  src: InstagramLogo
})`
    cursor: pointer;
`;

SignStyled.LinkedinIcon = styled.img.attrs({
    src: LinkedinLogo
})`
    cursor: pointer;
`;

SignStyled.DownloadIcon = styled.img.attrs({
  src: DownloadIcon
})``;

SignStyled.DownloadButton = styled.div`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: ${BACKGROUND.blue};
  width: 160px;
  cursor: pointer;
  transition: 0.5s;

  &:hover {
        background-color: ${BACKGROUND.darkblue};
    }
`;

SignStyled.DownloadText = styled.p`
  margin: 0px;
  color: #FFF;
  font-size: ${FONTSIZE.bigP};
  font-weight: ${FONTWEIGHT.normal};
`;

SignStyled.UploadIcon = styled.img.attrs({
    src: UploadIcon
  })``;

SignStyled.Asterisco = styled.img.attrs({
    src: AsteriscoIcon
  })`
    position: relative;
    top: -4px;
`;

SignStyled.DesktopDiv = styled.div`
    display: flex;
    gap: 16px;

    @media (max-width: 1300px) {
    flex-direction: column;
  }
`;

SignStyled.UploadInputContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;